import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

// NOTE: the Files drawer's OPEN-STATE now lives in the unified `drawerStore`
// (`frontend/src/state/drawerStore.ts`, panel==='files') as of unified-drawer P3 —
// see plans/unified-drawer.md. This store is now ONLY a refresh-token bus: bumping
// `refreshToken` forces every mounted `SectionContent` to reload its file list (e.g.
// after the agent creates/modifies files mid-turn). The former `open`/`openDrawer`/
// `closeDrawer` + `files-drawer-open` localStorage key were removed (dead since r29).

interface FileDrawerStore {
  /** Incremented to force SectionContent to reload its file list */
  refreshToken: number;
  /** Bump refreshToken — triggers reload in all open SectionContent instances */
  refresh: () => void;
}

export const useFileDrawerStore = create<FileDrawerStore>()(
  subscribeWithSelector((set) => ({
    refreshToken: 0,
    refresh: () => set((s) => ({ refreshToken: s.refreshToken + 1 })),
  })),
);
